import { IPageConfig } from "../../types";

let config: IPageConfig = {
    geoBaseDistance: 2,
    geoNumRange: [3, 7],
    geoValueRange: [3, 37],
    geoBasePosY: 0,
    cameraPosZ: 19,
    animationSpeed: 800,
}


export default config;